module.exports = __webpack_public_path__ + "img/logo_fm_app_l.19e53655.png";